import styled from 'styled-components'

const FlexDivStyle = styled.div`
    display: flex;
    justify-content: ${({justify}) => justify ? justify : 'normal' };
    align-items: ${({align}) => align ? align : 'start' };
`

export default FlexDivStyle
